import Vue from 'vue'
import Vuex from 'vuex'
import { IMLogin } from '../tim.js'
import TIM from 'tim-js-sdk'
import { emoji } from '../../emoji-data'
import {
  isJson,
  replaceRegExp
} from '../../../util.js'

Vue.use(Vuex)

const state = {
  tim: null, // Tim对象
  isReady: false, // 是否连接成功
  currentConversationID: '', // 当前聊天对话ID
  currentConversation: {}, // 当前聊天对话信息
  currentMessageList: [], // 当前聊天消息列表
  nextReqMessageID: '', // 最后一条聊天记录的发送时间
  filterRulesList: [], // 过滤关键字列表（正则表达式）
  isLoadFilterRules: false // 是否加载过关键字列表（正则表达式）
}

const mutations = {
  update(state, payload) {
    for (const key in payload) {
      Vue.set(state, key, payload[key])
    }
  },
  setTim: (state, payload) => {
    state.tim = payload
  },
  setIsReady: (state, payload) => {
    state.isReady = payload
  },
  setCurrentConversationID: (state, payload) => {
    state.currentConversationID = payload
  },
  setCurrentConversation: (state, payload) => {
    state.currentConversation = payload
  },
  // 设置聊天记录
  setCurrentMessageList: (state, payload) => {
    state.currentMessageList = payload
  },
  // push聊天记录
  pushCurrentMessageList: (state, payload) => {
    state.currentMessageList.push(payload)
  },
  // unShift聊天记录
  unShiftCurrentMessageList: (state, payload) => {
    state.currentMessageList.unshift(payload)
  },
  setNextReqMessageID: (state, payload) => {
    state.nextReqMessageID = payload
  },
}
const actions = {
  // 登录IM
  async loginIM({ commit }, userId) {
    const IM = await IMLogin(userId)
    commit('setTim', IM)
    commit('setNextReqMessageID', '')
    return IM
  },
  // 连接会话
  enterConversation({ commit, dispatch }, params = {}) {
    var { conversationId, conversationType, isCreateGroup } = params
    conversationType = conversationType || 'GROUP'
    const tim = state.tim
    conversationId = conversationId || state.currentConversationID
    return new Promise(function (resolve, reject) {
      // 寻找是否存在指定id的会话
      const promise = tim.searchGroupByID(conversationId)
      promise.then(async function (imResponse) {
        const group = imResponse.data.group // 群组信息
        commit('setCurrentConversation', group)
        await dispatch('joinGroup', { conversationId: conversationId, conversationType: conversationType })
        dispatch('updateTimMyProfile')
        resolve(group)
      }).catch(async function (error) {
        if (error.code === 10015 && isCreateGroup) {
          await actions.createGroup(conversationId, conversationId)
          const respose = await dispatch('enterConversation')
          resolve(respose)
        }
        reject(error)
      })
    })
  },
  // 加入群组
  joinGroup({ dispatch }, { conversationId, conversationType }) {
    const tim = state.tim
    return new Promise(function (resolve, reject) {
      const promise = tim.joinGroup({
        groupID: conversationId,
        type: TIM.TYPES.GRP_PUBLIC
      })
      promise.then(function (imResponse) {
        // 加入的群组资料
        switch (imResponse.data.status) {
          case 'AlreadyInGroup':
            // dispatch('getHistoryMessage', { conversationId: conversationId, conversationType: conversationType })
            break // 等待管理员同意
          case TIM.TYPES.JOIN_STATUS_WAIT_APPROVAL:
            break // 等待管理员同意
          case TIM.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
            // 加入的群组资料
            // dispatch('updateTimMyProfile')
            break
          default:
            break
        }
        resolve(imResponse)
      }).catch(function (imError) {
        // this.$message.error('进入聊天室失败')
        console.warn('joinGroup error:', imError) // 申请加群失败的相关信息
        reject(imError)
      })
    })
  },
  // 创建群组
  createGroup(roomId, roomName) {
    return new Promise(function (resolve, reject) {
      const tim = state.tim
      const promise = tim.createGroup({
        groupID: roomId,
        type: TIM.TYPES.GRP_PUBLIC,
        name: roomName.substring(0, 30),
        joinOption: TIM.TYPES.JOIN_OPTIONS_FREE_ACCESS
      })
      promise.then(function (imResponse) { // 创建的群的资料
        resolve(imResponse.data.group)
      }).catch(function (imError) {
        this.$message.error('创建聊天室失败')
        console.warn('createGroup error:', imError) // 创建群组失败的相关信息
        reject(imError)
      })
    })
  },
  // 发送消息
  sendMessage({ commit, dispatch }, message, conversationId, conversationType = 'GROUP') {
    const tim = state.tim
    conversationId = conversationId || state.currentConversationID
    const cType = conversationType.toUpperCase() === 'GROUP' ? TIM.TYPES.CONV_GROUP : TIM.TYPES.CONV_C2C
    // const textIsJson = isJson(message.payload.text)
    // if (textIsJson) {
    //   textIsJson.fromId = ''
    //   textIsJson.fromName = ''
    // }
    return new Promise(async function (resolve, reject) {
      const messageTim = tim.createTextMessage({
        to: conversationId,
        conversationType: cType,
        payload: {
          text: JSON.stringify(message)
        }
      })
      // 2. 发送消息
      const promise = tim.sendMessage(messageTim)
      promise.then(async function (imResponse) {
        // 发送成功
        const msg = actions.formatMessage(imResponse.data.message)
        console.log('msg', msg)
        await Vue.axios.post('/chat/sendScheduleMessage', {
          conversationId: conversationId,
          sysType: msg.sysType || '',
          messBody: msg.messBody,
          to: conversationId,
        }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
        msg.messBody = await dispatch('filterKeyWord', msg.messBody)
        commit('pushCurrentMessageList', msg)
        resolve(imResponse)
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  // 收到消息
  async onMessageEvent({ commit, dispatch }, event) {
    const list = event.data
    for (const item of list) {
      const msg = actions.formatMessage(item)
      msg.messBody = await dispatch('filterKeyWord', msg.messBody)
      commit('pushCurrentMessageList', msg)
    }
  },

  // 获取历史消息并更新vuex
  async getHistoryMessage({ state, commit, dispatch }, params = {}) {
    let { conversationId, conversationType, nextReqMessageID } = params
    conversationId = conversationId || state.currentConversationID
    conversationType = conversationType || 'GROUP'
    nextReqMessageID = nextReqMessageID || state.nextReqMessageID
    const messageList = await actions.getHistoryByDatabase(conversationId, conversationType, nextReqMessageID || '')
    if (messageList.length > 0) {
      nextReqMessageID = messageList[0].sendTime
      commit('setNextReqMessageID', nextReqMessageID)
    }
    for (const item of messageList.reverse()) {
      item.sysType = item.sysType ? item.sysType * 1 : ''
      item.messBody = await dispatch('filterKeyWord', item.messBody)
      commit('unShiftCurrentMessageList', item)
    }
  },
  // 获取Tim历史消息
  getHistoryByTIM(id, type, nextReqMessageID = '') {
    const tim = state.tim
    return new Promise(async function (resolve, reject) {
      const promise = tim.getMessageList({
        conversationID: type + id,
        count: 15,
        nextReqMessageID: nextReqMessageID
      })
      promise.then(function (imResponse) {
        console.log('getHistory', imResponse.data)
        const imResponseData = imResponse.data
        resolve(imResponseData)
      }).catch(function (imError) {
        console.warn('login error:', imError) // 登录失败的相关信息
        reject(imError)
      })
    })
  },

  // 获取历史消息
  async getHistoryByDatabase(id, type, nextReqMessageID = '') {
    const rz = await Vue.axios.post('/chat/getScheduleMessageList', {
      conversationId: id,
      lastTime: nextReqMessageID,
      size: 30
    }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    return rz
  },

  // 更新资料
  updateTimMyProfile() {
    const tim = state.tim
    const userInfo = Vue.ls.get('USER_INFO')
    console.log('userInfo', userInfo)
    // 修改名称
    const options = {
      nick: userInfo.nickName || userInfo.stuName,
      avatar: userInfo.headImgUrl
    }
    return new Promise(function (resolve, reject) {
      const promise = tim.updateMyProfile(options)
      promise.then(function (imResponse) {
        resolve(imResponse)
      }).catch(function (imError) {
        console.warn('updateMyProfile error:', imError) // 更新资料失败的相关信息
        reject(imError)
      })
    })
  },
  // 重新组装聊天记录，区分客服消息和课堂互动
  formatMessage(message) {
    let newMess = {}
    if (message.payload.text) {
      const textIsJson = isJson(message.payload.text)
      if (!textIsJson) {
        // 客服im-纯文本
        newMess.messBody = (message.payload.text + '').replace(/\n/g, '<br/>')
      } else {
        // 课堂im-文本中带有其他属性
        newMess = JSON.parse(message.payload.text)
        if (typeof (message.messBody) === 'string') {
          newMess.messBody = message.messBody.replace(/\n/g, '<br/>')
        }
      }
    } else if (message.payload.data && message.payload.extension) {
      // 客服im-自定义消息
      try {
        newMess = JSON.parse(message.payload.extension)
      } catch (e) {
        newMess = message.payload
      }
    }
    newMess.messBody = actions.replaceEmoji(newMess.messBody)
    newMess.isSystem = message.isSystemMessage
    newMess.fromId = message.from
    newMess.fromPhoto = message.avatar
    newMess.fromName = newMess.fromName || message.nick
    newMess.id = message.ID
    newMess.isRevoked = message.isRevoked // 是否撤回
    return newMess
  },
  replaceEmoji(str) {
    if (typeof (str) !== 'string') {
      return str
    }
    // eslint-disable-next-line no-useless-escape
    const replacedStr = str.replace(/\[([^(\]|\[)]*)\]/g, (item, index) => {
      for (let i = 0; i < emoji.length; i++) {
        const EM = emoji[i]
        if (EM.alt === item) {
          // 在线表情路径，图文混排必须使用网络路径，请上传一份表情到你的服务器后再替换此路径
          if (!EM.icon) {
            const imgstr = '<img style="height:22px;width:22px;" src="' + process.env.VUE_APP_OBS_URL_ASSETS + 'img-emoji/' + EM.url + '">'
            return imgstr
          } else {
            const imgstr = '<span style="font-size:22px">' + EM.icon + '</span>'
            return imgstr
          }
        }
        return item
      }
    })
    return replacedStr || str
  },
  async getKeyWord(context) {
    let ruleList = context.state.filterRulesList
    console.log('ruleList', ruleList)
    if ((!ruleList || ruleList.length === 0) && !context.state.isLoadFilterRules) {
      try {
        ruleList = await Vue.axios.get(`/b/classes/keywordFilterRules/list?type=LiveChat`)
      } catch (e) { }
      context.commit('update', {
        isLoadFilterRules: true
      })
      // ruleList = [{
      //   rule: '微信'
      // }, {
      //   rule: '(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\\d{8}'
      // }]
      context.commit('update', {
        filterRulesList: ruleList
      })
    }
    return ruleList
  },
  async filterKeyWord(context, msg) {
    console.log()
    if (typeof (msg) !== 'string') {
      return msg
    }
    let res = ''
    let ruleList = context.state.filterRulesList
    if ((!ruleList || ruleList.length === 0) && !context.state.isLoadFilterRules) {
      ruleList = await context.dispatch('getKeyWord')
    }
    const keys = []
    for (const item of ruleList) {
      item.rule && keys.push(item.rule)
    }
    res = replaceRegExp(msg.toString(), keys)
    return res
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
